import axios from '../../axios'
import { action, makeObservable, observable } from 'mobx'
// import { toast } from 'react-toastify'
import { PredictionObjectType } from './types'

type ObjectProgress = {
  objectId: number
  objectType: PredictionObjectType
  percentCompleted: number
  numberOfTasks: number
  aiProcess: string
}

type ObjectsProgress = {
  [objectType: string]: {
    [objectId: number]: ObjectProgress
  }
}

type Item = {
  objectId: string
  objectType: string
}

export class ObjectsProgressStore {
  objectsProgress: ObjectsProgress = {}

  constructor() {
    makeObservable(this, {
      objectsProgress: observable,
      setObjectsProgress: action,
    })
  }

  reset = () => {}

  setObjectsProgress = (array: ObjectProgress[]) => {
    array.forEach((item) => {
      if (!this.objectsProgress[item.objectType]) {
        this.objectsProgress[item.objectType] = {}
      }
      this.objectsProgress[item.objectType][item.objectId] = item
    })
  }

  fetchObjectsProgress = async (objects: Item[]) => {
    // /api/v1/dashboard/progress
    const params: string[] = []
    objects.forEach((item, index) => {
      const key = encodeURIComponent(`processesInfo[${index}]`)
      const parsedItem = `${key}.objectId=${item.objectId}&${key}.objectType=${item.objectType}`
      params.push(parsedItem)
    })
    return await axios
      .get(`/api/v1/dashboard/progress?${params.join('&')}`)
      .then(({ data }) => {
        this.setObjectsProgress(data.processesInfo)
        return data.processesInfo;
      })
  }
}

export const objectsProgressStore = new ObjectsProgressStore()
